import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
export interface LinkWithDescriptionCellRendererParams {
  url?: string;
  showLink?: boolean;
  linkTestSelector?: string;
  title?: string;
  description?: string;
}

@Component({
    template: `<div class="custom-line-height-cell text-truncate">
      @if(showLink){
      <a
        [attr.data-test-selector]="linkTestSelector"
        class="no-underline"
        [href]="url"
        >{{ title }}</a
      >
      } @else {
      {{ title }}
      }
    </div>
    <div class="custom-line-height-cell text-truncate text-gray-600">
      {{ description }}
    </div>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LinkWithDescriptionCellRendererComponent
  implements ICellRendererAngularComp
{
  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  title?: string;
  description?: string;
  showLink?: boolean;
  url?: string;
  linkTestSelector?: string;

  agInit({
    url,
    showLink,
    linkTestSelector,
    title,
    description,
  }: CustomParams): void {
    this.title = title;
    this.description = description;
    this.showLink = showLink;
    this.url = url;
    this.linkTestSelector = linkTestSelector;
    this.changeDetectorRef.detectChanges();
  }
  refresh(): boolean {
    return false;
  }
}
interface CustomParams
  extends ICellRendererParams<string>,
    LinkWithDescriptionCellRendererParams {}
